/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Remove_RowInputs */

const vi_shop_home_remove_row = /** @type {(inputs: Shop_Home_Remove_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xoá dòng`)
};

/**

* @param {Shop_Home_Remove_RowInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_remove_row = /** @type {((inputs?: Shop_Home_Remove_RowInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Remove_RowInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_remove_row(inputs)
});